var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { injectIntl } from "@irati/utils/lang";
import id from "@irati/utils/id";
import withBranding from "@irati/brand/withBranding";
import UpdateBrand from "../../../components/Settings/Brand";
import SuccessWithBackLink from "../../../components/SuccessWithBackLink";
import { SETTINGS_CUSTOMISE_BRAND } from "../../../routes/routeConfig";
var CompanyBrand = /** @class */ (function (_super) {
    __extends(CompanyBrand, _super);
    function CompanyBrand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            saved: false
        };
        _this.onBrandUpdated = function () {
            _this.setState({ saved: true });
            setTimeout(function () {
                _this.setState({ saved: false });
            }, 2000);
        };
        return _this;
    }
    CompanyBrand.prototype.render = function () {
        var saved = this.state.saved;
        var idNamespace = id("company-brand", this.props);
        var formatMessage = this.props.formatMessage;
        return (React.createElement("div", { id: idNamespace },
            React.createElement(React.Fragment, null, saved ?
                React.createElement(SuccessWithBackLink, { id: idNamespace, message: formatMessage({ id: "admin.containers.companyBrand.fullModal.success.message" }), backLink: SETTINGS_CUSTOMISE_BRAND })
                :
                    React.createElement(UpdateBrand, { id: idNamespace, onBrandUpdated: this.onBrandUpdated, imageLink: this.props.branding.businessLogoUrl }))));
    };
    return CompanyBrand;
}(PureComponent));
export default withBranding(injectIntl(CompanyBrand));
